import React from 'react';
import { Route, Switch } from "react-router-dom";
import Places from '../containers/Admin/Tables/ParamPlaces';
import Home from './Home/Home';
import Actions from '../containers/Actions/TableActions';
import FormActions from '../containers/Actions/FormActions';
import MyCalendar from './Calendar/Calendar';
import Quicksight from './Quicksight/Quicksight';
import TableMaintenances from '../containers/Maintenances/TableMaintenances';
import TableExpiredServices from '../containers/Admin/Tables/TableExpiredServices';
import Powerbi from './PowerBi/PowerBi';
import ScheduledServicesPlanner from '../containers/ScheduledServices/ScheduledServicesPlanner/ScheduledServicesPlanner';
import ScheduledServicesCalendar from '../containers/ScheduledServices/ScheduledServicesCalendar/ScheduledServicesCalendar';
import PowerbiNew from './PowerBiNew/PowerBi';

const Routes = () => {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/places" exact component={Places} />
      <Route path="/actions" component={Actions} />
      <Route path="/maintenances" component={TableMaintenances} />
      <Route path="/calendar" component={MyCalendar} />
      <Route path="/quicksight" component={Quicksight} />
      <Route path="/powerbi/new" exact component={PowerbiNew} />
      <Route path="/powerbi" exact component={Powerbi} />
      <Route path="/form-action/:id" component={FormActions} />
      <Route path="/expired-services" component={TableExpiredServices} />
      <Route path="/scheduled-services-planner" component={ScheduledServicesPlanner} />
      <Route path="/scheduled-services-calendar" component={ScheduledServicesCalendar} />
    </Switch>
  );
}
export default Routes;
